var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0098C24.8366 32.0098 32 24.8463 32 16.0098C32 7.17321 24.8366 0.00976562 16 0.00976562C7.16344 0.00976562 0 7.17321 0 16.0098C0 24.8463 7.16344 32.0098 16 32.0098Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5225 13.9228H31.8653C30.8426 6.07239 24.1299 0.00976562 16.0007 0.00976562C14.8061 0.00976562 13.6424 0.141828 12.5225 0.390078V13.9228H12.5225Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34812 13.9226V1.95508C3.95474 4.3522 0.80968 8.74914 0.135742 13.9227H8.34812V13.9226Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34805 18.0967H0.135742C0.80968 23.2702 3.95474 27.6672 8.34812 30.0642L8.34805 18.0967Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5225 18.0967V31.6294C13.6424 31.8777 14.8061 32.0097 16.0007 32.0097C24.1299 32.0097 30.8426 25.9471 31.8653 18.0967H12.5225V18.0967Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSweden);
export default __webpack_public_path__ + "static/media/flag_sweden.7a60abec1aa0aa466a93a72f0198c9eb.svg";
export { ForwardRef as ReactComponent };